import { GridCellProps } from '@progress/kendo-react-grid';
import { useCallback, useContext } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import Button from 'src/components/design-system/Button';
import { EditCellContext } from 'src/contexts/EditCellContext';

const TransactionLog = (props: GridCellProps) => {
  const { dataItem } = props;
  const [cellClick] = useContext(EditCellContext);
  const handleClick = useCallback(
    (e: any) => {
      e.stopPropagation();
      cellClick?.({ data: dataItem, type: 'logAmount' });
    },
    [cellClick, dataItem]
  );
  return (
    <GridCellBase
      {...props}
      disableToolTip
      className="!text-center !p-0 relative"
      rowSelectionEnabled
    >
      {!dataItem.isNewGlCode && (
        <Button
          color="secondary"
          onClick={handleClick}
          size="sm"
          className={`absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-[50%] mx-auto !my-0`}
        >
          View
        </Button>
      )}
    </GridCellBase>
  );
};

export default TransactionLog;
